export const SkillData = [
    {
        name: "ReactJs",
        icon: <i class="devicon-react-original colored"></i>
    },
    {
        name: "VueJs",
        icon: <i class="devicon-vuejs-plain colored"></i>
    },
    {
        name: "NuxtJs",
        icon: <i class="devicon-nuxtjs-plain colored"></i>
    },
    {
        name: "NodeJs",
        icon: <i class="devicon-nodejs-plain-wordmark"></i>
    },
    {
        name:"Javascript",
        icon: <i class="devicon-javascript-plain colored"></i>
    },
    {
        name: "HTML5",
        icon: <i class="devicon-html5-plain-wordmark colored"></i>

    },
    {
        name: "CSS3",
        icon: <i class="devicon-css3-plain-wordmark colored"></i>

    },
    {
        name:"Mysql",
        icon:<i class="devicon-mysql-plain colored"></i>
    },
    {
        name:"Gulp",
        icon: <i class="devicon-gulp-plain colored"></i>
    }

]